import { Injectable, Inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
// import { saveAs } from 'file-saver';
// import { LazyService, LazyResult } from '../util';
import { ZipConfig, DA_ZIP_CONFIG, ZipSaveOptions } from "./interface";

declare var JSZip: any;
declare var saveAs: any;
@Injectable()
export class ZipService {
    constructor(
        @Inject(DA_ZIP_CONFIG) private config: ZipConfig,
        private http: HttpClient
    ) // private lazy: LazyService,
    {}

    private init(): Promise<any[]> {
        const config = Object.assign(
            {
                //  url: `//cdn.bootcss.com/jszip/3.1.5/jszip.min.js`,
                utils: []
            },
            this.config
        );
        return new Promise(resolve => {
            resolve([]);
        });
        // return this.lazy.load([config.url].concat(config.utils));
    }

    private check(zip: any) {
        if (!zip) {
            throw new Error("get instance via `ZipService.create()`");
        }
    }

    /** è§£å */
    read(fileOrUrl: File | string, options?: any): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            this.init().then(() => {
                // from url
                if (typeof fileOrUrl === "string") {
                    this.http
                        .request("GET", fileOrUrl, {
                            responseType: "arraybuffer"
                        })
                        .subscribe(
                            (res: ArrayBuffer) => {
                                JSZip.loadAsync(res, options).then(ret =>
                                    resolve(ret)
                                );
                            },
                            (err: any) => {
                                reject(err);
                            }
                        );
                    return;
                }
                // from file
                const reader: FileReader = new FileReader();
                reader.onload = (e: any) => {
                    JSZip.loadAsync(e.target.result, options).then(ret =>
                        resolve(ret)
                    );
                };
                reader.readAsBinaryString(<File>fileOrUrl);
            });
        });
    }

    /** åå»º Zip å®ä¾ï¼ç¨äºåå»ºåç¼©æä»¶ */
    create(): Promise<any> {
        return new Promise<any>(resolve => {
            this.init().then(() => {
                const zipFile: any = new JSZip();
                resolve(zipFile);
            });
        });
    }

    /**
     * ä¸è½½URLèµæºå¹¶åå¥ zip
     * @param zip Zip å®ä¾
     * @param path Zip è·¯å¾ï¼ä¾å¦ï¼ `text.txt`ã`txt/hi.txt`
     * @param url URL å°å
     */
    pushUrl(zip: any, path: string, url: string): Promise<void> {
        this.check(zip);
        return new Promise<void>((resolve, reject) => {
            this.http
                .request("GET", url, { responseType: "arraybuffer" })
                .subscribe(
                    (res: ArrayBuffer) => {
                        zip.file(path, res);
                        resolve();
                    },
                    (error: any) => {
                        reject({ url, error });
                    }
                );
        });
    }

    /**
     * ä¿å­Zipå¹¶æ§è¡æå¼ä¿å­å¯¹è¯æ¡
     *
     * @param zip zip å¯¹è±¡ï¼å¡å¿éè¿ `create()` æå»º
     * @param options é¢å¤åæ°ï¼
     */
    save(zip: any, options?: ZipSaveOptions): Promise<void> {
        this.check(zip);
        const opt = Object.assign({}, options);
        return new Promise<void>((resolve, reject) => {
            zip.generateAsync(
                Object.assign({ type: "blob" }, opt.options),
                opt.update
            ).then(
                (data: Blob) => {
                    if (opt.callback) {
                        opt.callback(data);
                    }
                    saveAs(data, opt.filename || "download.zip");
                    resolve();
                },
                err => {
                    reject(err);
                }
            );
        });
    }
}
